module.exports = __webpack_public_path__ + "chip_black.c28d6f0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/landing/black/chip_black.png
// module id = 939
// module chunks = 0